import { SearchMagnifyingGlass } from "@/icons";
import { useTranslate } from "@/providers/context";

export const EmptyResults = ({
  query,
  filtersSelected,
}: {
  query?: string;
  filtersSelected: boolean;
}) => {
  const { translate } = useTranslate();

  const noSearchCriteria = !query && !filtersSelected;
  const needsMoreSearchCriteria =
    (!query || query.length < 3) && !filtersSelected;
  const stillTyping = !!query && query.length < 3 && !filtersSelected;
  const searchString = query ? `“${query}”` : "your filters";

  return (
    <div className="flex flex-col items-center pt-[335px]">
      <SearchMagnifyingGlass className="text-item-primary h-[68px] w-[68px]" />
      <div className="h4-bold text-item-primary w-[240px] pt-[16px] text-center">
        {needsMoreSearchCriteria
          ? translate("Search")
          : translate("No Results")}
        <div className="p1 text-item-secondary pt-[8px]">
          {noSearchCriteria
            ? translate("Start typing keywords to search")
            : stillTyping
              ? translate("Please enter at least 3 characters")
              : `${translate("We could not find anything matching")} ${searchString}.`}
        </div>
      </div>
    </div>
  );
};
